import { render, staticRenderFns } from "./AdministrationFileExportManage.vue?vue&type=template&id=3f88e3f9&scoped=true"
import script from "./AdministrationFileExportManage.vue?vue&type=script&lang=js"
export * from "./AdministrationFileExportManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f88e3f9",
  null
  
)

export default component.exports